import {
  Text,
  IconExclamationTriangle,
  IconMagnifyingGlass,
  GreyGrey60,
  Primary13Regular,
  RedRed50,
  Box,
  Flex
} from '@sequencehq/core-components'
import Spinner from 'components/Loading'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`

const ShimmerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.6) 50%,
    transparent 100%
  );
  animation: ${shimmer} 2s ease-in-out infinite;
`

type StatusType =
  | 'processing'
  | 'generating'
  | 'searching'
  | 'looking'
  | 'error'

interface StatusIndicatorProps {
  type: StatusType
  message: string
}

const StatusIcon = ({ type }: { type: StatusType }) => {
  if (type === 'processing') {
    return <IconMagnifyingGlass color={GreyGrey60} />
  }

  if (type === 'error') {
    return <IconExclamationTriangle color={RedRed50} />
  }

  // Default spinner for other types
  return <Spinner width="12px" height="12px" color={GreyGrey60} />
}

export const StatusIndicator = ({ type, message }: StatusIndicatorProps) => {
  const shouldPulse = type !== 'error'

  return (
    <Box
      width="100%"
      position="relative"
      display="flex"
      alignItems="center"
      overflow="hidden"
    >
      {shouldPulse && <ShimmerOverlay />}
      <Flex
        gap={2}
        align="center"
        width="100%"
        p={2}
        position="relative"
        zIndex={0}
      >
        <StatusIcon type={type} />
        <Text color={GreyGrey60} {...Primary13Regular}>
          {message}
        </Text>
      </Flex>
    </Box>
  )
}
